//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import item_manghua_base from "./manghua_base";


export default {
  name: 'item_manghu_row',
  mixins: [item_manghua_base],
  data() {
    return {}
  },
}
